import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSparkleFilled16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "currentColor",
		children: /* @__PURE__ */ _jsx("path", { d: "M6.51 3h-.02a1 1 0 0 0-.929.629L4.438 6.438 1.628 7.56A1 1 0 0 0 1 8.49v.02a1 1 0 0 0 .629.929l2.808 1.124 1.124 2.808A1 1 0 0 0 6.49 14h.02a1 1 0 0 0 .929-.629l1.124-2.809L11.37 9.44A1 1 0 0 0 12 8.51v-.02a1 1 0 0 0-.629-.929L8.562 6.438 7.44 3.628A1 1 0 0 0 6.51 3M13.438 2.563l-.51-1.273a.462.462 0 0 0-.857 0l-.508 1.273-1.273.508a.462.462 0 0 0 0 .858l1.273.509.508 1.272a.462.462 0 0 0 .858 0l.508-1.272 1.273-.51a.462.462 0 0 0 0-.857z" })
	})
});
const ForwardRef = forwardRef(SvgIconSparkleFilled16);
export default ForwardRef;
